import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EdlPublicComponent } from "./public/edl-public.component";
import { EdlAuthenticatedNavigationComponent } from "./authenticated/edl-authenticated-navigation.component";
import { BannerModule, EdlAuthenticatedModule, EdlCommonDirectiveModule, EdlCommonPipesModule } from '@edl-development/edl-common';
import { AuthenticatedHeaderComponent } from './authenticated/authenticated-header/authenticated-header.component';
import { AuthenticatedComponent } from './authenticated/authenticated/authenticated.component';
import { PaetepDirectiveModule } from '../directives/paetep-directive.module';
import { EdlCommonAuthenticationModule } from '@edl-development/edl-auth';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule,
        NgbModule,
        EdlCommonDirectiveModule,
        EdlCommonPipesModule,
        EdlAuthenticatedModule,
        PaetepDirectiveModule,
        BannerModule,
        EdlCommonAuthenticationModule
    ],
    declarations: [
        AuthenticatedComponent,
        AuthenticatedHeaderComponent,
        EdlPublicComponent,
        EdlAuthenticatedNavigationComponent
    ]
})
export class LayoutModule { }
